export default "__VITE_ASSET__CXc5zcO4__"